
class CampaignPlanningConfirmationAdBuilder {
    constructor() {
        this.main = document.getElementById('campaign-planning-ad-builder');
        if (this.main) {
            this.price = this.main.dataset.price;
            this.amount = this.main.dataset.amount;

            this._containerAdBuilder = this.main.querySelector('.ad-builder-container');
            this._inputCheckbox = this.main.querySelector('input[type="checkbox"]');

            this._inputCheckbox.addEventListener('change', this._onChangeInput.bind(this))
        }
    }

    _onChangeInput() {
        this.main.dispatchEvent(
            new CustomEvent('adBuilderCreditsChange', {
                detail: {
                    active: this._inputCheckbox.checked,
                    price: this.price,
                    amount: this.amount
                }
            })
        );
    }

    get isActive() {
        return this._inputCheckbox.checked;
    }

    returnData() {
        return {
            amount: this.amount,
            price: this.price
        }
    }

    show() {
        this.main.classList.remove('d-none');
    }

    hide() {
        this.main.classList.add('d-none');
    }

    addEventListener(event, callback) {
        if (this.main) return this.main.addEventListener(event, callback);
    }
}

export default CampaignPlanningConfirmationAdBuilder;